import {
  AccessTime,
  BrokenImage,
  ChangeHistory,
  Dashboard,
  ViewList,
} from '@mui/icons-material';
import { ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import { StyledDrawerList } from './StyledDrawerList';

interface Props {
  drawerOpen: boolean;
}

const HistoryList = ({ drawerOpen }: Props) => {
  const isAdmin = useIsAdmin();

  return (
    <StyledDrawerList sx={{ padding: 0 }}>
      <ListItemButton component={Link} to='/' key={'Dashboard'}>
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary={'Dashboard'} />
      </ListItemButton>
      <ListItemButton component={Link} to='/trace-history'>
        <ListItemIcon>
          <BrokenImage />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary='Trace History' />
        ) : (
          <ListItemText primary='Link' />
        )}
      </ListItemButton>
      <ListItemButton component={Link} to='/marker-history'>
        <ListItemIcon>
          <ChangeHistory style={{ transform: 'rotate(180deg)' }} />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary='Marker History' />
        ) : (
          <ListItemText primary='Link' />
        )}
      </ListItemButton>
      <ListItemButton component={Link} to='/time-warning-log'>
        <ListItemIcon>
          <AccessTime />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary={'Time Warning Log'} />
        ) : (
          <ListItemText primary='Link' />
        )}
      </ListItemButton>
      {isAdmin && (
        <>
          <ListItemButton component={Link} to='/system-log'>
            <ListItemIcon>
              <ViewList />
            </ListItemIcon>
            {drawerOpen ? (
              <ListItemText primary='System Log' />
            ) : (
              <ListItemText primary='Link' />
            )}
          </ListItemButton>
        </>
      )}
    </StyledDrawerList>
  );
};

export default HistoryList;
